import React from 'react';
import styles from './Footer.module.scss';

type PrivateProps = {
  mouseCoords?: number[];
};

export default function Footer({ mouseCoords }: PrivateProps) {
  return (
    <div className={styles.footer}>
      <div className={`${styles.left}`}>
        <div className={`${styles.links}`}>
          <a
            href="https://www.dhigroup.com/disclaimer"
            target="_blank"
            rel="noreferrer"
          >
            Disclaimer
          </a>
          <a
            href="https://www.dhigroup.com/terms-of-use"
            target="_blank"
            rel="noreferrer"
          >
            Terms of use
          </a>
          <a
            href="https://www.dhigroup.com/privacy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy policy
          </a>
          <a
            href="https://www.dhigroup.com/cookie-page"
            target="_blank"
            rel="noreferrer"
          >
            Cookie policy
          </a>
        </div>
      </div>
      <div className={styles.center}>
       {mouseCoords && (
          <div className={styles.mouseCoords}>
            {`Longitude [°E], Latitude [°N]: ${mouseCoords?.[0]}, ${mouseCoords?.[1]}`}
          </div>
        )}
      </div>
      <div className={styles.right}>
        <div>
          &copy; <a href="https://www.mapbox.com/about/maps" target='_blank' rel="noreferrer">Mapbox</a> |
          &copy; <a href="https://www.openstreetmap.org/about/" target='_blank' rel="noreferrer">OpenStreetMap</a>
           contributors
        </div>
      </div>
    </div>
  );
}
